import { render, staticRenderFns } from "./itinerary_hotel.vue?vue&type=template&id=2ef862da&"
import script from "./itinerary_hotel.vue?vue&type=script&lang=js&"
export * from "./itinerary_hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260304115753/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef862da')) {
      api.createRecord('2ef862da', component.options)
    } else {
      api.reload('2ef862da', component.options)
    }
    module.hot.accept("./itinerary_hotel.vue?vue&type=template&id=2ef862da&", function () {
      api.rerender('2ef862da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_hotel.vue"
export default component.exports